import React from 'react';
import { PERMISSIONS } from '../../contexts/PermissionsContext';
import { Link as RouterLink } from 'react-router-dom';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import {
	Wrapper,
	Help,
	Link,
	ImageContainer,
	TextContainer,
	Title,
	Text,
	Actions,
	ActionSection,
	LoadingContainer,
} from './styles';
import { ScrollContainer } from '../Data.styles';

export const NoDataWrapper = ({ children }) => (
	<Wrapper>
		<ImageContainer />
		<TextContainer>{children}</TextContainer>
	</Wrapper>
);

export const NoDataContentStatic = () => (
	<React.Fragment>
		<Title>No data available</Title>
		<Text>
			Thank you for your patience. You’ll receive an email to let you know when
			data is uploaded.
		</Text>
		<Help>
			<Link href="mailto:helpdesk@alixpartners.com">
				helpdesk@alixpartners.com
			</Link>
		</Help>
	</React.Fragment>
);

export const NoDataContent = ({ permissions, config }) => {
	const canUpload = permissions.includes(PERMISSIONS.RawDataWrite);
	const canConfigureDpaas = permissions.includes(
		PERMISSIONS.SettingsClassificationWrite
	);
	const isConfigExists = config && config.isAlreadyExists;

	return (
		<React.Fragment>
			<Title>
				{!isConfigExists
					? "There's currently no data to display"
					: 'Environment ready'}
			</Title>
			<Text>
				{!isConfigExists
					? 'Choose to upload a file or configure the application for automated DPaaS data ingestion'
					: 'The environment is configured ready for the first DPaaS data ingestion. If you need to change the configuration, click Settings.'}
			</Text>
			<Actions>
				{!isConfigExists ? (
					<React.Fragment>
						{canUpload && (
							<ActionSection>
								<RouterLink to="/data">
									<ApButtonSecondary iconName="cloud_queue">
										Upload the data
									</ApButtonSecondary>
								</RouterLink>
							</ActionSection>
						)}
						{canConfigureDpaas && (
							<ActionSection>
								<RouterLink
									to={{
										pathname: '/dpaas',
										state: {
											config,
										},
									}}
								>
									<ApButtonMain iconName="settings_outline">
										configure for dpaas
									</ApButtonMain>
								</RouterLink>
							</ActionSection>
						)}
					</React.Fragment>
				) : (
					<ActionSection>
						<RouterLink to="/settings/classification">
							<ApButtonSecondary iconName="settings_outline">
								Settings
							</ApButtonSecondary>
						</RouterLink>
					</ActionSection>
				)}
			</Actions>
		</React.Fragment>
	);
};

const NoDataContainer = ({ permissions, config }) => {
	const canUpload = permissions.includes(PERMISSIONS.RawDataWrite);
	const canConfigureDpaas = permissions.includes(
		PERMISSIONS.SettingsClassificationWrite
	);

	if (canConfigureDpaas && !config) {
		return (
			<ScrollContainer>
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			</ScrollContainer>
		);
	}

	if (!canUpload && !canConfigureDpaas) {
		return (
			<ScrollContainer>
				<NoDataWrapper>
					<NoDataContentStatic />
				</NoDataWrapper>
			</ScrollContainer>
		);
	}

	return (
		<ScrollContainer>
			<NoDataWrapper>
				<NoDataContent permissions={permissions} config={config} />
			</NoDataWrapper>
		</ScrollContainer>
	);
};

export default NoDataContainer;
